<ng-container *ngIf="meta.show && visibilidad">
  <mat-card [class]="'meta-mapping componente componente--' + meta.categoria.ordenAgrupador"
            [ngClass]="{'conexion-origen': (meta.conexiones.selfColor.length > 1 && meta.conexiones.active)}"
            [style.backgroundColor]="meta.conexiones.activeColor">
    <div>
      <div style="position: absolute; height: 100%; width: 100%; top: 0; left: 0; background: rgba(0,0,0, 0.6)"
           *ngIf="maskOn"></div>
      <div
        style="cursor: pointer;position: absolute; height: 100%; width: 100%; top: 0; left: 0; background: rgba(255,255,255, 0.6)"
        *ngIf="isConectable"
        (click)="guardarEstadoConexion(!meta.isConnected)">
        <mat-icon style="position: absolute; top: calc(50% - 12px); left: calc(50% - 12px);"
                  [ngStyle]="{'color': meta.isConnected ? 'green' : 'red'}">
          {{meta.isConnected ? 'link' : 'link_off'}}
        </mat-icon>
      </div>
      <div style="position: absolute; height: 100%; width: 100%; top: 0; left: 0; background: rgba(255,255,255, 0.6)"
           *ngIf="isBulkActive"
           (click)="setEstadoBulk(!meta.bulkSelected)">
            <span
              style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; display: block; border: 3px solid green;"
              *ngIf="meta.bulkSelected"></span>
      </div>
      <div class="flex-wrap">
        <mat-card-title style="font-size: 13px; font-weight: bold;">
          {{meta.getCodigo()}}
          <!--<small>{{displayLang.indicador}}</small>-->
        </mat-card-title>
        <div class="spacer"></div>
        <ng-container *ngFor="let indicador of meta.conexionesActivas">
          <mat-icon matTooltip="{{indicador.codigo}}" class="indicador-conexion meta-header__indicador"
                    [style.color]="indicador.color">fiber_manual_record
          </mat-icon>
        </ng-container>
        <div *ngIf="!isConectable && !maskOn && !isBulkActive">
          <div *ngIf="!isEmisorConexion">
            <button mat-icon-button class="md-14" [matMenuTriggerFor]="menuMeta">
              <mat-icon class="material-icons md-14">more_vert</mat-icon>
            </button>
            <mat-menu #menuMeta="matMenu" xPosition="before" overlapTrigger="true">
              <button mat-menu-item *ngIf="meta.isEditable" title="Editar meta" (click)="editar(meta.id)">
                <mat-icon>mode_edit</mat-icon>
                <span i18n="editar | editar@@editar">Editar</span>
              </button>
              <button mat-menu-item title="Conexiones..." [matMenuTriggerFor]="conexionMenu">
                <mat-icon>remove_red_eye</mat-icon>
                <span i18n="conexions boton | conexiones boton@@conexionesBoton">Conexiones...</span>
              </button>
              <button mat-menu-item title="Conectar con otras metas" [ngClass]="{'on': conec}"
                      *ngIf="!meta.setBulk && meta.categoria.ordenAgrupador>1 && meta.isEditable"
                      (click)="conectarCon();">
                <mat-icon>link</mat-icon>
                <span i18n="conectar con metas | conectar con metas@@btnConectarMetas">Conectar con otras metas</span>
              </button>
            </mat-menu>
            <mat-menu #conexionMenu="matMenu">
              <button mat-menu-item title="Mostrar conexiones hacia arriba"
                      [ngClass]="{'active': meta.conexiones.status.up}"
                      *ngIf="!meta.setBulk && meta.categoria.ordenAgrupador>1"
                      (click)="mostrarConexiones('all');">
                <mat-icon
                  *ngIf="!meta.conexiones.status.up && !meta.conexiones.status.same && !meta.conexiones.status.down; else allcanceltpl">
                  transform
                </mat-icon>
                <ng-template #allcanceltpl>
                  <div style="position: relative; display: inline-block; width: 40px; height: 17px">
                    <mat-icon [ngStyle]="{'position': 'absolute', 'left': '0'}">transform</mat-icon>
                    <mat-icon
                      [ngStyle]="{'position': 'absolute', 'left': '0', top: 0, color: 'red'}">
                      not_interested
                    </mat-icon>
                  </div>
                </ng-template>
                <span i18n="boton estado todas las conexiones | boton estado todas las conexiones@@btnTodasConexiones">
                  <span
                    *ngIf="(meta.conexiones.status.up || meta.conexiones.status.same || meta.conexiones.status.down);else verTodasTpl">
                    Ocultar
                  </span>
                  <ng-template #verTodasTpl>Ver</ng-template>
                  todas las conexiones
                </span>
              </button>
              <button mat-menu-item title="Mostrar conexiones hacia arriba"
                      [ngClass]="{'active': meta.conexiones.status.up}"
                      *ngIf="!meta.setBulk && meta.categoria.ordenAgrupador>1"
                      (click)="mostrarConexiones('up');">
                <mat-icon *ngIf="!meta.conexiones.status.up; else upcanceltpl">arrow_back</mat-icon>
                <ng-template #upcanceltpl>
                  <div style="position: relative; display: inline-block; width: 40px; height: 17px">
                    <mat-icon [ngStyle]="{'position': 'absolute', 'left': '0'}">arrow_back</mat-icon>
                    <mat-icon
                      [ngStyle]="{'position': 'absolute', 'left': '0', top: 0, color: 'red'}">
                      not_interested
                    </mat-icon>
                  </div>
                </ng-template>
                <span i18n="boton estados conexiones | boton estados conexiones@@btnConexiones">
                  <span *ngIf="meta.conexiones.status.up;else verUpTpl">Ocultar</span>
                  <ng-template #verUpTpl>Ver</ng-template>
                  conexiones
                </span>
              </button>
              <button mat-menu-item title="Mostrar conexiones" [ngClass]="{'active': meta.conexiones.status.same}"
                      *ngIf="!meta.setBulk && meta.categoria.ordenAgrupador>1"
                      (click)="mostrarConexiones('same');">
                <mat-icon *ngIf="!meta.conexiones.status.same; else samecanceltpl">swap_vert</mat-icon>
                <ng-template #samecanceltpl>
                  <div style="position: relative; display: inline-block; width: 40px; height: 17px">
                    <mat-icon [ngStyle]="{'position': 'absolute', 'left': '0'}">swap_vert</mat-icon>
                    <mat-icon
                      [ngStyle]="{'position': 'absolute', 'left': '0', top: 0, color: 'red'}">
                      not_interested
                    </mat-icon>
                  </div>
                </ng-template>
                <span i18n="boton estados conexiones | boton estados conexiones@@btnConexiones">
                  <span *ngIf="meta.conexiones.status.same;else verSameTpl">Ocultar</span>
                  <ng-template #verSameTpl>Ver</ng-template>
                  conexiones
                </span>
              </button>
              <button mat-menu-item title="Mostrar conexiones hacia abajo"
                      [ngClass]="{'active': meta.conexiones.status.down}" *ngIf="!meta.setBulk"
                      (click)="mostrarConexiones('down');">
                <mat-icon *ngIf="!meta.conexiones.status.down; else downcanceltpl">arrow_forward</mat-icon>
                <ng-template #downcanceltpl>
                  <div style="position: relative; display: inline-block; width: 40px; height: 17px">
                    <mat-icon [ngStyle]="{'position': 'absolute', 'left': '0'}">arrow_forward</mat-icon>
                    <mat-icon
                      [ngStyle]="{'position': 'absolute', 'left': '0', top: 0, color: 'red'}">
                      not_interested
                    </mat-icon>
                  </div>
                </ng-template>
                <span i18n="boton estados conexiones | boton estados conexiones@@btnConexiones">
                  <span *ngIf="meta.conexiones.status.down; else verDownTpl">Ocultar</span>
                  <ng-template #verDownTpl>Ver</ng-template>
                  conexiones
                </span>
              </button>
            </mat-menu>
          </div>
          <div *ngIf="isEmisorConexion">
            <button mat-raised-button color="accent" (click)="finalizarConexion()"
                    i18n="finalizar | finalizar@@finalizar">Finalizar</button>
          </div>
        </div>
      </div>
      <mat-card-content>
        <div *ngIf="visibility">
            <div class="detail-element">
                <div *ngIf="!visibility.fullHtml; else full_html"
                        [innerHtml]="(meta.htmlIdioma | slice:0:100) + '...'"></div>
                <ng-template #full_html>
                    <div [innerHtml]="meta.htmlIdioma"></div>
                </ng-template>
            </div>
            <div class="detail-element" *ngIf="visibility.areas">
                <label i18n="@@materias">Materias</label>
                <ul *ngIf="meta.materias && meta.materias.length > 0;else no_areas">
                    <li *ngFor="let materia of meta.materias">
                    <span class="detail-list-item">{{materia.nombre}}</span>
                    </li>
                </ul>
                <ng-template #no_areas>
                    <p i18n="@@noMaterias">No hay materias asociadas</p>
                </ng-template>
            </div>
            <div class="detail-element" *ngIf="visibility.cursos">
                <label i18n="@@grados">Grados:</label>
                <ul *ngIf="meta.cursos && meta.cursos.length > 0;else no_cursos">
                    <li *ngFor="let curso of meta.cursos">
                    <span class="detail-list-item">{{curso.nickName}}</span>
                    </li>
                </ul>
                <ng-template #no_cursos>
                    <p i18n="@@noGrados">No hay cursos asociadas</p>
                </ng-template>
            </div>
            <div class="detail-element" *ngIf="visibility.ambitos">
                <label i18n="@@ambitos">Ámbitos</label>
                <ul *ngIf="meta.ambitos && meta.ambitos.length > 0;else no_ambitos">
                    <li *ngFor="let ambito of meta.ambitos">
                    <span class="detail-list-item">{{ambito.nombre}}</span>
                    </li>
                </ul>
                <ng-template #no_ambitos>
                    <p i18n="@@noAmbitos">No hay ámbitos asociados</p>
                </ng-template>
            </div>
            <div class="detail-element" *ngIf="visibility.tags">
                <label i18n="@@tags">Tags</label>
                <ul *ngIf="meta.tags && meta.tags.length > 0;else no_tags">
                    <li *ngFor="let tag of meta.tags">
                    <span class="detail-list-item">{{tag.nombre}}</span>
                    </li>
                </ul>
                <ng-template #no_tags>
                    <p i18n="@@noTags">No hay tags asociados</p>
                </ng-template>
            </div>
        </div>

      </mat-card-content>
    </div>
  </mat-card>
</ng-container>
